module.exports = __webpack_public_path__ + "GL_logo_black.b45326f74d0a4cea0d2fbfd1e7e1c53e.png";